import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class DoService {
  host_Do = `${environment.API_URI}/api/do`;

   constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getAllDo() {
    const url = `${this.host_Do}/select/all`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  getDoById(code_interne: number) {
    const url = `${this.host_Do}/select/${code_interne}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  updateDoByCI(code_interne: number, DO: any) {
    const url = `${this.host_Do}/update/${code_interne}`;
    return this.http.put(url, DO, { headers: this.getAuthHeaders() });
  }
}